interface PendingCartItem {
  productId: string;
  planType: string;
  amount: number;
  timestamp: number;
  fromPage: string;
}

export const usePendingCart = () => {
  const { isProcessingSignOut } = useAuthHandler();
  const COOKIE_NAME = "pendingCartItems";
  const EXPIRE_TIME = 30 * 60 * 1000; // 30 分鐘

  // 共享的 cookie 實例
  const cookie = useCookie<PendingCartItem[]>(COOKIE_NAME, {
    maxAge: 60 * 30, // 30 分鐘
    sameSite: "strict",
    secure: process.env.NODE_ENV === "production",
    default: () => [],
  });

  const savePendingCartItem = (
    productId: string,
    planType: string,
    fromPage: string = "chat",
    amount: number = 1
  ) => {
    if (isProcessingSignOut.value) {
      console.log("Sign out in progress, skipping savePendingCartItem");
      return;
    }
    const pendingItems = getPendingCartItems();
    console.log("Current items before save:", pendingItems);

    const newItem: PendingCartItem = {
      productId,
      planType,
      amount,
      timestamp: Date.now(),
      fromPage,
    };

    const existingIndex = pendingItems.findIndex(
      (item) => item.productId === productId
    );

    if (existingIndex !== -1) {
      pendingItems[existingIndex] = newItem;
      console.log("Updated existing item:", pendingItems);
    } else {
      pendingItems.push(newItem);
      console.log("Added new item, total items:", pendingItems.length);
    }

    cookie.value = pendingItems;
    console.log("Cookie set to:", cookie.value);
  };

  const getPendingCartItems = (): PendingCartItem[] => {
    if (isProcessingSignOut.value) {
      console.log("Sign out in progress, skipping savePendingCartItem");
      return [];
    }
    try {
      const items = cookie.value || [];

      if (!Array.isArray(items)) {
        console.error("Cookie items is not an array:", items);
        cookie.value = [];
        return [];
      }

      const now = Date.now();

      const validItems = items.filter((item) => {
        if (
          !item ||
          typeof item !== "object" ||
          typeof item.productId !== "string" ||
          typeof item.timestamp !== "number"
        ) {
          console.warn("Invalid cart item found:", item);
          return false;
        }
        return now - item.timestamp < EXPIRE_TIME;
      });

      if (validItems.length !== items.length) {
        cookie.value = validItems;
      }

      return validItems;
    } catch (error) {
      console.error("Error processing pending cart items:", error);
      cookie.value = [];
      return [];
    }
  };

  const clearPendingCartItems = () => {
    cookie.value = [];
  };

  const removePendingCartItem = (productId: string) => {
    const pendingItems = getPendingCartItems();
    const filteredItems = pendingItems.filter(
      (item) => item.productId !== productId
    );
    cookie.value = filteredItems;
  };

  return {
    savePendingCartItem,
    getPendingCartItems,
    clearPendingCartItems,
    removePendingCartItem,
  };
};
